import Axios from 'axios';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react'
import NotData from '../../components/NotData';
import { useNavigate } from 'react-router-dom';
import { elapsedTime } from '../../common/howDate';
import NotToDate from './Components/NotToDate';

const BcBeMeCancel = () => {

  // 시간 불러오는 부분
  let toDate = new dayjs().format('YYYY-MM-DD');
  let toTime = new dayjs().format('YYYY-MM-DD HH:mm:ss')

  const minusDate = (number)=>{
    const now = new dayjs().subtract(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const plusDate = (number)=>{
    const now = new dayjs().add(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const toDay = {
    date: toDate,
    time: toTime,
    minusDate,
    plusDate
  }
    
  const [books, setBooks] = useState([]);
  const columns = [ 'No', '브랜드', '분류', '제품 이름', '수량', '반출', '반입', '매입', '취소', '매장', '시간' ];

  const basicStore = window.sessionStorage.getItem('basicStore');

  const [selectDate, setSelectDate] = useState(()=>{
    if(window.sessionStorage.getItem('bcbemeDate')){
      return window.sessionStorage.getItem('bcbemeDate');
    } else {
      return toDay.date;
    }
  });

  const [itemIno, setItemIno] = useState('');
  const [itemNo, setItemNo] = useState('');
  const [itemBrand, setItemBrand] = useState('');
  const [itemType, setItemType] = useState('');
  const [itemName, setItemName] = useState('');
  const [itemCount, setItemCount] = useState('');
  const [itemT1, setItemT1] = useState('');
  const [itemT2, setItemT2] = useState('');
  const [itemDate, setItemDate] = useState('');

  const [toDayDate, setToDayDate] = useState('');
  
  // 날짜 및 바로 실행될 부분
  useEffect(()=>{
    document.title = '취소 내역';

    setToDayDate(()=>{
      if(window.sessionStorage.getItem('bcbemeDate')){
        return window.sessionStorage.getItem('bcbemeDate');
      } else {
        return toDay.date;
      }
    });

    BEDataLoade();
  }, [])
        
  // 반출 반입 매입 취소 데이터 불러오기
  const BEDataLoade = async () => {
    await Axios.get(`/api/bcbemeCancel/cancellist`, {
      params: { Date: window.sessionStorage.getItem('bcbemeDate') ?? toDay.date }
    })
    .then((res) => {
      if (res.data.length) {
        setBooks(res.data);
      } else {
        setBooks([]);
      }
    });
  };

  // 날짜 변경시
  const ChangedDate = async (e)=>{
    window.sessionStorage.setItem('bcbemeDate', e.target.value);

    setSelectDate(e.target.value);

    await Axios.get(`/api/bcbemeCancel/cancellist`, {
      params: { Date: e.target.value }
    })
    .then((res)=>{
      if (res.data.length) {
        setBooks(res.data);
      } else {
        setBooks([]);
      }
    })

    setSelectedRow(-1);
  };

  // 셀렉트 테스트
  const [selectedRow, setSelectedRow] = useState(-1);

  const navigate = useNavigate();
    
  return (
    <div className='p-3 flex flex-col gap-3 whitespace-nowrap'>
    <div className='flex justify-between items-center overflow-x-auto'>
      <ul className='flex gap-3'>
        <li className={`hover:underline cursor-pointer py-2 px-3 overflow-x-auto`} onClick={()=>navigate('/bcbeme/bc')}>제품 반출</li>
        <li className={`hover:underline cursor-pointer py-2 px-3 overflow-x-auto`} onClick={()=>navigate('/bcbeme/be')}>제품 반입</li>
        <li className={`hover:underline cursor-pointer py-2 px-3 overflow-x-auto`} onClick={()=>navigate('/bcbeme/me')}>제품 매입</li>
        <li className={`hover:underline cursor-pointer py-2 px-3 overflow-x-auto border-[1px] border-yellow-500 rounded-md`} onClick={()=>navigate('/bcbeme/cancel')}>취소내역</li>
      </ul>
      {/* <div>
        <button className='px-5 py-3 text-yellow-400'>새로고침</button>
      </div> */}
    </div>
    
    
    <div className='grid grid-cols-1 md:flex md:justify-between text-sm md:h-[calc(100vh-8.9rem)] gap-1'>
      
      {/* 메인 */}
      <div className='relative border-[1px] border-gray-500 w-full md:w-3/4 md:h-full h-[60vh] overflow-y-auto'>
        <table id='testTable' className='w-full'>
          <thead className='bg-[#1E1E1E]/90 whitespace-nowrap text-center sticky top-0 z-10'>
            <tr className='border-b-[1px] border-gray-500'>
              {columns.map((column) => (
                <th className='p-3' key={column}>{column}</th>
              ))}
            </tr>
          </thead>
          <tbody className='text-center'>
            {
              books.length ?
              books.map((book, idx) => (
                <tr className=
                {`
                  duration-150 decoration-yellow-600 whitespace-nowrap active:scale-[0.98] active:opacity-80
                  ${selectedRow === idx ? 'bg-[#1E1E1E] font-bold underline decoration-[3px]' : 'even:bg-[#3E3E3E]'}
                `}
                  key={book.no} onClick={(e)=>{
                  setSelectedRow(idx);
                  setItemIno(book.i_no);
                  setItemNo(book.no);
                  setItemBrand(book.brand);
                  setItemType(book.type);
                  setItemName(book.name);
                  setItemCount(book.count);
                  setItemT1(book.t1);
                  setItemT2(book.t2);
                  setItemDate(book.date);

                  window.sessionStorage.setItem('select_copy', book.name);
                }}>
                  <td className='p-2.5'>{idx + 1}</td>
                  <td className='p-2.5 border-x-[1px] border-gray-500'>{book.brand}</td>
                  <td className='p-2.5 border-x-[1px] border-gray-500'>{book.type}</td>
                  <td className='p-2.5 border-x-[1px] border-gray-500'>{book.name}</td>
                  <td className='p-2.5 border-x-[1px] border-gray-500'>{book.count} 개</td>
                  <td className='p-2.5 border-l-[1px] border-gray-500'>{!book.t1 ? '-' : book.t1}</td>
                  <td className='p-2.5 border-r-[1px] border-gray-500'>{!book.t2 ? '-' : book.t2}</td>
                  <td className='p-2.5 border-x-[1px] border-gray-500'>{!book.t3 ? '-' : book.t3}</td>
                  <td className='p-2.5 border-l-[1px] border-gray-500'>{!book.t4 ? '-' : book.t4}</td>
                  <td className={`p-2.5 border-r-[1px] border-gray-500 ${basicStore === book.store && 'text-yellow-400'}`}>{book.store}</td>
                  <td className={`p-2.5 ${elapsedTime(book.date) === '방금 전' && 'animate-pulse'}`}>
                    {elapsedTime(book.date)}
                  </td>
                </tr>
              ))
              :
              <tr className='relative'>
                <td className='absolute w-full md:top-[30vh] top-[25vh]'>
                  <NotData/>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      {/* 사이드 */}
      <div className='md:w-1/4 w-full md:overflow-y-auto bg-[#424242] border-[1px] border-gray-500'>

        <div className='bg-[#0067BD] py-2 text-center'>
          <p className='text-left pl-3'>
            ※ 반출 반입 매입 취소내역
          </p>
        </div>

        {/* 당일 날짜와 지정한 날짜가 일치하지 않을 경우  안내 */}
        {
          selectDate !== toDay.date ?
            <NotToDate/>
          : null
        }

        <div className='p-3 flex flex-col gap-2'>

          {/* 날짜 조회 */}
          <div className='flex gap-2'>
            <div className='w-full'>
              <p>취소 날짜 조회</p>
              <input type='date' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400' value={toDayDate} onChange={(e)=>{
                setToDayDate(e.target.value);
                ChangedDate(e);
              }}/>
            </div>
          </div>

          {/* 언더라인 */}
          <div className='border-b-[1px] border-gray-400 py-1'></div>
          
        </div>

      </div>

    </div>

  </div>
  )
}

export default BcBeMeCancel